import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import BusinessIcon from '@material-ui/icons/Business';
import {getLabel} from "../../localization/MainLocalization";
import "../../assets/scss/Static.scss";
import {Link} from 'react-router-dom';

export const ListItems = () => {
    return (
        <>

            <ListItem button component={Link} to='/dashboard'>
                <ListItemIcon>
                    <BusinessIcon/>
                </ListItemIcon>
                <ListItemText primary={getLabel('dashboard')} className="Side-menu-item"/>
            </ListItem>

            <ListItem button component={Link} to='/import-data'>
                <ListItemIcon>
                    <BusinessIcon/>
                </ListItemIcon>
                <ListItemText primary="Import data" className="Side-menu-item"/>
            </ListItem>

            <ListItem button component={Link} to='/actions'>
                <ListItemIcon>
                    <BusinessIcon/>
                </ListItemIcon>
                <ListItemText primary="Actions" className="Side-menu-item"/>
            </ListItem>

        </>
    );
}
